<template>
  <div id="bjzc-team-detail">
    <div uk-grid>
      <div class="bjzc-team-detail-photo uk-flex-none uk-visible@m">
        <img :src="lawyerInfo.avatarUrl" class="border-radius" alt="" />
      </div>
      <div class="bjzc-team-detail--info uk-flex-1">
        <PageHeading>{{ $getLocaleValue(lawyerInfo, 'name') }}</PageHeading>
        <div class="bjzc-team-detail-photo uk-text-center uk-hidden@m">
          <img :src="lawyerInfo.avatarUrl" class="border-radius" alt="" />
        </div>
        <h4>{{ $getLocaleValue(lawyerInfo, 'title') }}</h4>

        <div v-html="$getLocaleValue(lawyerInfo, 'content')"></div>

        <ContactForm />
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from '../components/ContactForm.vue'
export default {
  name: '',
  props: ['id'],
  components: { ContactForm },
  data() {
    return {
      lawyerInfo: {
        name: '-'
      }
    }
  },
  created() {
    this.getLawyerInfo()
  },
  methods: {
    getLawyerInfo() {
      this.$axios.get('lawyers/' + this.id).then(res => {
        this.lawyerInfo = res.data
        const r = this.$route
        this.$eventBus.$emit('setBreadcrumb', [
          { path: '/', title: '首页', title_en: 'Home' },
          {
            path: '/team',
            title: this.$t('breadcrumb.team', 'zh'),
            title_en: this.$t('breadcrumb.team', 'en')
          },
          {
            path: r.fullPath,
            title: this.lawyerInfo.name,
            title_en: this.lawyerInfo.nameEn || this.lawyerInfo.name
          }
        ])
      })
    }
  }
}
</script>

<style lang="scss">
#bjzc-team-detail {
  .bjzc-team-detail-photo > img {
    width: 14rem;
  }
}
</style>
